import sliceCreator from '../../index.jsx';
import {UPDATE_TENANT_USER_STATUS} from '../../../constants/index.jsx';
const _updateTenantUserStatusAction = sliceCreator('UPDATE_TENANT_USER_STATUS', UPDATE_TENANT_USER_STATUS, 'put');

const { asyncAction: updateTenantUserStatusAction, reducer, clearData: clearUpdateTenantUserStatusAction } = _updateTenantUserStatusAction;

export default reducer;

export {
    updateTenantUserStatusAction,
    clearUpdateTenantUserStatusAction
}